import { memo, ReactNode } from 'react';
import { StyledDescriptionTooltip } from './styled';

interface DescriptionTooltipProps {
  activator: ReactNode;
  content: ReactNode;
}

const DescriptionTooltip = ({ activator, content }: DescriptionTooltipProps) => {
  return (
    <StyledDescriptionTooltip>
      <div className="tooltip-activator">{activator}</div>
      <div className="tooltip-content">{content}</div>
    </StyledDescriptionTooltip>
  );
};

export default memo(DescriptionTooltip);
